import ManagerialTree from 'managerialTree';
import { MANAGERIAL_TREE_ROUTE_ID } from './common';

export default {
    [MANAGERIAL_TREE_ROUTE_ID]: () => <ManagerialTree />
};
